import { CognitoAuthCallbackPage } from "@/features/auth/pages/CognitoAuthCallback";

const CognitoAuthCallback = () => {
  return <CognitoAuthCallbackPage />;
};

export default CognitoAuthCallback;
